import { put, select } from 'redux-saga/effects';
import { authActions } from 'Containers/Auth/store';
import { getActiveSalonId, getSalonsRaw } from 'Containers/Auth/store/selectors';
import { readInviteTotal } from './inviteJourney';

/** Copia residuo e totale dalle API sul salone attivo, così la UI non resta sul valore del login. */
export function* applyInviteQuotaFromApi(payload) {
  if (!payload) return;
  const hasRemaining = payload.inviti_onboarding !== undefined && payload.inviti_onboarding !== null;
  const total = Object.prototype.hasOwnProperty.call(payload, 'inviti_onboarding_tot')
    ? readInviteTotal(payload.inviti_onboarding_tot)
    : null;
  if (!hasRemaining && total == null) return;

  const salonId = yield select(getActiveSalonId());
  const salons = yield select(getSalonsRaw());
  const salon = (salons || []).find((item) => +item.idsalone === +salonId);
  if (!salon) return;

  yield put(authActions.EDIT_SALON_INFO.SUCCESS({
    idsalone: salon.idsalone,
    ...(hasRemaining ? { inviti_onboarding: payload.inviti_onboarding } : {}),
    ...(total != null ? { inviti_onboarding_tot: total } : {}),
  }));
}
